import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { Colors } from "../../../../theme";
import { useTranslation } from "react-i18next";

const Templates = () => {
  const location = useLocation();
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const { t } = useTranslation() as any;

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath.includes("/checklist/templates/checklists"))
      setSelectedIndex(0);
    if (currentPath.includes("/checklist/templates/tasks")) setSelectedIndex(1);
    if (currentPath.includes("/checklist/templates/categories"))
      setSelectedIndex(2);
  }, [location]);

  return (
    <Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box style={{ display: "flex", justifyContent: "flex-start" }}>
          <Typography color={Colors.black} variant="h6">
            {t("26_00_templates").toUpperCase()}
          </Typography>
        </Box>

        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "center",
            gap: "40px",
            flex: 1,
          }}
        >
          <Link
            to="/checklist/templates/checklists"
            style={{
              fontWeight: "400",
              fontSize: "13px",
              cursor: "pointer",
              textDecoration: "none",
              color: selectedIndex === 0 ? Colors.primary : Colors.black,
              whiteSpace: "nowrap",
            }}
            onClick={() => setSelectedIndex(0)}
          >
            {t("26_00_checklists")}
          </Link>

          <Link
            to="/checklist/templates/tasks"
            style={{
              fontWeight: "400",
              fontSize: "13px",
              cursor: "pointer",
              textDecoration: "none",
              color: selectedIndex === 1 ? Colors.primary : Colors.black,
              whiteSpace: "nowrap",
            }}
            onClick={() => setSelectedIndex(1)}
          >
            {t("00_01_tasks")}
          </Link>

          <Link
            to="/checklist/templates/categories"
            style={{
              fontWeight: "400",
              fontSize: "13px",
              cursor: "pointer",
              textDecoration: "none",
              color: selectedIndex === 2 ? Colors.primary : Colors.black,
              whiteSpace: "nowrap",
            }}
            onClick={() => setSelectedIndex(2)}
          >
            {t("21_00_category")
              .replace(/category/i, "categories")
              .replace(/\b\w/, (c) => c.toUpperCase())}
          </Link>
        </Box>
      </Box>
      <Box
        style={{
          width: "100%",
          borderBottom: "2px solid #E0E0E0",
          marginTop: "24px",
          marginBottom: "10px",
        }}
      />
      <Outlet />
    </Box>
  );
};

export default Templates;
